export const SESSION_CIAN_APP_TOOLTIP_KEY = 'cian_app_tooltip_key';
